import { defineStore } from 'pinia'

const normalizeMode = (value) => {
  const normalized = String(value ?? '').trim().toLowerCase()
  return normalized === 'signup' ? 'signup' : 'signin'
}

export const useAuthModalStore = defineStore('authModal', {
  state: () => ({
    isOpen: false,
    mode: 'signin'
  }),

  actions: {
    open(mode = 'signin') {
      this.mode = normalizeMode(mode)
      this.isOpen = true
    },

    close() {
      this.isOpen = false
    }
  }
})
